export default "__VITE_ASSET__BZKF4wj1__"